import React from 'react';
import CubeCalculator from "./CubeCalculator";
import CylinderCalculator from "./CylinderCalculator";
import TruncatedConeCalculator from "./TruncatedConeCalculator";

let classNames = require("classnames");

class ContainerShape extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOption: null
        };

        this.handleShapeChange = this.handleShapeChange.bind(this);
    }

    handleShapeChange(changeEvent) {
        this.setState({
            selectedOption: changeEvent.target.value
        });
    }

    render() {
        let calculatorForm = '';
        let selectedOption = this.state.selectedOption;
        if (selectedOption === 'Kubus'){
            calculatorForm = <CubeCalculator />
        } else if(selectedOption === 'Cilinder'){
            calculatorForm = <CylinderCalculator />
        } else if(selectedOption === 'Afgeknotte kegel'){
            calculatorForm = <TruncatedConeCalculator />
        }
        let sizes = [
            'Kubus',
            'Cilinder',
            'Afgeknotte kegel'
        ];

        return <div>
            <div className="radio-buttons">
                <p>Welke vorm heeft uw pot?</p>
                {sizes.map((name) => {
                    let className = name.replace(' ', '-').toLowerCase();
                    return <label htmlFor={name} key={name} className={classNames({
                        className : true,
                        "active": this.state.selectedOption === name
                    })}>
                        <span>{name}</span>
                        <input
                            type="radio"
                            name="containerShape"
                            id={name}
                            value={name}
                            checked={this.state.selectedOption === name}
                            onChange={this.handleShapeChange} />
                    </label>
                })}
            </div>
            <div className="formblock">
                {calculatorForm}
            </div>
        </div>
    }
}

export default ContainerShape;